import { SITE } from '@/data';

const API = process.env.REACT_APP_BACKEND_URL;

/* Forms post through our backend relay — Klaviyo blocks direct browser calls
   from this origin (verified: their edge only allows the OPTIONS preflight here). */

export function ukPhone(raw) {
  const d = (raw || '').replace(/[^\d+]/g, '');
  if (!d) return '';
  if (d.startsWith('+')) return d;
  if (d.startsWith('44')) return '+' + d;
  if (d.startsWith('0')) return '+44' + d.slice(1);
  return d;
}

export async function subscribe(listId, email, source, extra = {}) {
  const res = await fetch(`${API}/api/klaviyo/subscribe`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ listId, email, source, firstName: extra.first_name || '', phone: extra.mobile_number || '' })
  });
  if (!res.ok) throw new Error(`Subscribe failed ${res.status}`);
}

export async function sendPick(pick, handle) {
  const res = await fetch(`${API}/api/klaviyo/pick`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ pick, handle, metric: SITE.klaviyo.nextPickMetric })
  });
  if (!res.ok) throw new Error(`Pick failed ${res.status}`);
}

export async function sendDjSignup({ djName, email, phone }) {
  const res = await fetch(`${API}/api/dj-signup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ djName, email, phone, djListId: SITE.klaviyo.djListId })
  });
  if (!res.ok) throw new Error(`DJ signup failed ${res.status}`);
}

export const emailOk = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
